import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

interface RoleDashboardRouteProps {
  children: ReactNode;
  requiredRoles?: number[];
}

const RoleDashboardRoute = ({ children }: RoleDashboardRouteProps) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Bypassed: allow all dashboards to all users
  return <>{children}</>;
};

export default RoleDashboardRoute;
